var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { Checkbox, Typography } from '@robinpowered/ui-kit';
import { useTranslation } from 'react-i18next';
import { useFormContext, useWatch } from 'react-hook-form';
export var PrivacyToggle = function () {
    var t = useTranslation('meetingRooms').t;
    var setValue = useFormContext().setValue;
    var isPrivateEvent = useWatch({
        name: 'isPrivateEvent',
    });
    return (_jsx(Checkbox, { checked: isPrivateEvent, onChange: function (checked) {
            setValue('isPrivateEvent', checked.target.checked, {
                shouldDirty: true,
            });
        }, children: t('create_event.mark_private') }));
};
export var PrivacyHeading = styled(Typography.Text)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  line-height: 24px;\n  margin-left: 12px;\n"], ["\n  line-height: 24px;\n  margin-left: 12px;\n"])));
var templateObject_1;
